import { render, staticRenderFns } from "./Column.vue?vue&type=template&id=522b312f&scoped=true&"
import script from "./Column.vue?vue&type=script&lang=js&"
export * from "./Column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522b312f",
  null
  
)

export default component.exports